import { Table } from "antd";
import styled from "styled-components";

export const StyledTable = styled(Table)`
  .ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
    height: 220px;
  }
  .ant-table.ant-table-scroll-horizontal {
    background: transparent;
    color: #ffffffd9;

    .ant-table-cell.ant-table-selection-column {
      padding: 0 8px !important;
    }
    .ant-table-thead tr th {
      &:before {
        display: none;
      }
      padding: unset;
      height: 44px;
    }

    .ant-table-cell {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      height: 44px;
      padding-top: 0;
      padding-bottom: 0;
      padding: 0 16px !important;
      // color: rgba(255, 255, 255, 0.85);
      &::before {
        display: none;
      }
    }

    .ant-table-thead .ant-table-cell {
      background: #414144;
    }

    .ant-checkbox-inner {
      background: transparent;
      border: 1px solid rgba(255, 255, 255, 0.65);
      border-radius: 3px;
    }

    .ant-table-tbody > tr.ant-table-row-selected > td,
    .ant-table-tbody > tr.ant-table-row:hover > td,
    .ant-table-tbody .ant-table-row > .ant-table-cell.ant-table-cell-row-hover {
      background: transparent;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .ant-table-filter-column {
      justify-content: initial;
    }

    .ant-table-column-title {
      flex: none;
      z-index: 0;
    }

    .ant-table-filter-trigger.active,
    .ant-table-filter-trigger:hover {
      color: var(--main-color);
    }
    .ant-table-tbody > .ant-table-placeholder {
      background: rgb(41, 43, 47) !important;
      .ant-table-expanded-row-fixed {
        color: #ffffffd9;
      }
    }
    .ant-table-tbody > tr.ant-table-placeholder:hover > td {
      background: transparent;
    }

    .ant-empty-description {
      color: rgba(255, 255, 255, 0.85);
    }

    .ant-table-cell-scrollbar:not([rowspan]) {
      box-shadow: none;
    }

    .ant-checkbox-indeterminate .ant-checkbox-inner::after {
      background: var(--main-color);
    }
    .ant-checkbox-indeterminate .ant-checkbox-inner {
      border-color: var(--main-color) !important;
    }

    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner,
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox-checked::after {
      border-color: var(--main-color) !important;
    }
    .ant-checkbox-disabled .ant-checkbox-inner {
      background: #414245;
      border: 1px solid #545758 !important;
    }

    .ant-table-container::after {
      z-index: unset;
    }

    .ant-table-filter-dropdown {
      background: #333336;
    }

    .ant-table-filter-dropdown .ant-dropdown-menu {
      background: #333336;
      border-radius: 2px;
    }

    .ant-table-filter-dropdown-btns {
      border-top: 1px solid rgba(0, 0, 0, 0.03) !important;
    }

    .ant-btn-link,
    .ant-btn-link[disabled],
    .ant-btn-link[disabled]:hover,
    .ant-btn-link:hover {
      color: var(--color-main-help);
    }

    .ant-btn-primary,
    .ant-checkbox-checked,
    .ant-checkbox-checked .ant-checkbox-inner,
    .ant-btn-primary:hover {
      color: #ffffff;
      border-color: var(--main-color);
      background: var(--main-color) !important;
    }

    .ant-checkbox-inner {
      background: #333336;
      border-radius: 2px;
    }
    .ant-dropdown
      .ant-table-filter-dropdown
      .ant-dropdown-menu
      li.ant-dropdown-menu-item {
      .ant-dropdown-menu-title-content {
        .ant-checkbox-inner {
          background: #2c2c31;
          border: 1px solid #3b3e42;
        }
      }
      &:hover {
        background: var(--color-main-alpha-1);
        .ant-dropdown-menu-title-content {
          span {
            color: var(--color-main-help);
          }
        }
      }
    }
    .ant-dropdown-menu-item-selected,
    .ant-dropdown-menu-item:hover,
    .ant-dropdown-menu-item.ant-dropdown-menu-item-active {
      background-color: var(--color-main-alpha-1) !important;
      color: var(--main-color) !important;
    }

    .ant-table-selection {
      .ant-checkbox-indeterminate {
        .ant-checkbox-inner {
          background-color: var(--main-color);
          &::after {
            height: 2px;
            background-color: #ffffff !important;
          }
        }
      }
    }
    .grey-row {
      color: #939393;
    }
  }
`;
